import React, { useState, useEffect } from "react";
import {
  Layout,
  Modal,
  AppointmentBookingForm,
  CallAppointmentBooking,
  OTP,
  IconHeader
} from "components";
import { Form, Button } from "react-bootstrap";
import "../style.scss";
import {
  appointmentBooking,
  changeAppointmentBooking
} from "services/api-service";

import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch, batch } from "react-redux";

import {
  SeparatorLine,
  NextButton,
  DataLabel,
  InputText,
  CommonButton,
  StepperBar
} from "components/CommonUI";

import moment from "moment";

import {
  DEFAULT_ROUTE,
  APPOINTMENT_EXISTENCE,
  APPOINTMENT_ACKNOWLEDGEMENT,
  CALL_APPOINTMENT_ACKNOWLEDGEMENT
} from "constants/route";

import { changeMobile } from "redux/appointment";
import {
  changeRegisteredAppointmentId,
  changeRegisteredApptTimeslotId,
  changeDisplaySelectedDate,
  changeDisplaySelectedTime,
  changeDisplaySelectedService,
  changeBookingTxnId,
  changeTransTime
} from "redux/appointmentBooking";
import { ValidateMobileData, INDEX } from "constants/appointment";
import {
  DAY_MONTH_YEAR,
  YEAR_MONTH_DAY_HOUR_MINUTE_SECOND,
  YEAR_MONTH_DAY_HOUR_MINUTE
} from "constants/date";

const { MOBILE_INDEX } = INDEX;
const ZERO = 0;
const YES = "1";
const HOME = "home";
const ERROR = "error";

export default function AppointmentBooking() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [validateErrors, setValidateErrors] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isVisibleOtpForm, setIsVisibleOtpForm] = useState(false);
  const [verifiedOTP, setVerifiedOTP] = useState(false);
  const [alreadyTaken, setAlreadyTaken] = useState(false);
  const [message, setMessage] = useState({ title: "", body: "", type: HOME });
  const [stepperItems, setStepperItems] = useState([
    { text: "Personal Information", current: true, complete: false },
    { text: "Make an Appointment", current: false, complete: false }
  ]);

  const { nric, mobile, enquiryId, age, language, service } = useSelector(
    (state) => state.appointment
  );
  const { displayText, icon } = useSelector((state) => state.services);
  const {
    selectedDate,
    attendingWithAnother,
    selectedTimeSlot,
    selectedService,
    anotherSelectedTimeSlot,
    anotherNric,
    defaultLocationId,
    displaySelectedService,
    selectedApptType,
    displaySelectedDate,
    displaySelectedTime,
    bookingTxnId,
    registeredAppointmentId,
    registeredApptTimeslotId
  } = useSelector((state) => state.appointmentBooking);

  const { mainId, subServiceId } = useSelector((state) => state.services);

  const [isOpenModal, setIsOpenModal] = useState(false);

  useEffect(() => {
    if (registeredAppointmentId && ValidateMobileData(mobile).length === ZERO) {
      setVerifiedOTP(true);
      setIsVisibleOtpForm(true);
    }
  }, []);

  useEffect(() => {
    if (verifiedOTP) {
      setStepperItems([
        { text: "Personal Information", current: false, complete: true },
        { text: "Make an Appointment", current: true, complete: false }
      ]);
    } else {
      setStepperItems([
        { text: "Personal Information", current: true, complete: false },
        { text: "Make an Appointment", current: false, complete: false }
      ]);
    }
  }, [verifiedOTP]);

  const goHome = () => navigate(DEFAULT_ROUTE);

  const onConfirm = () => {
    setIsOpenModal(true);
    goHome();
    // No need to warn to user
    // setMessage({
    //   title: "User Data",
    //   body: "Your filling data will be deleted.",
    //   type: HOME
    // });
  };

  const onHideModal = () => setIsOpenModal(false);

  const handleAppointment = async () => {
    let response;

    const appointmentDate = moment(
      `${selectedDate} ${selectedTimeSlot.label}`,
      YEAR_MONTH_DAY_HOUR_MINUTE
    ).format(YEAR_MONTH_DAY_HOUR_MINUTE_SECOND);

    const anotherAppointmentDate =
      attendingWithAnother === YES
        ? moment(
            `${selectedDate} ${anotherSelectedTimeSlot.label}`,
            YEAR_MONTH_DAY_HOUR_MINUTE
          ).format(YEAR_MONTH_DAY_HOUR_MINUTE_SECOND)
        : "";

    const birthYear = moment(age).year();

    const locationId = defaultLocationId
      ? defaultLocationId
      : selectedService.value;

    registeredAppointmentId && registeredApptTimeslotId
      ? (response = await changeAppointmentBooking(
          mainId,
          subServiceId,
          enquiryId,
          nric,
          birthYear,
          language,
          service,
          mobile,
          selectedApptType.value,
          attendingWithAnother,
          locationId,
          appointmentDate,
          Number(selectedTimeSlot.value),
          Number(registeredAppointmentId),
          Number(registeredApptTimeslotId),
          anotherNric ? anotherNric : "",
          anotherAppointmentDate,
          Number(anotherSelectedTimeSlot.value),
          bookingTxnId
        ))
      : (response = await appointmentBooking(
          mainId,
          subServiceId,
          enquiryId,
          nric,
          birthYear,
          language,
          service,
          mobile,
          selectedApptType.value,
          attendingWithAnother,
          locationId,
          appointmentDate,
          Number(selectedTimeSlot.value),
          anotherNric ? anotherNric : "",
          Number(anotherSelectedTimeSlot.value),
          anotherAppointmentDate,
          selectedService.label
        ));

    if (response.status === 200) {
      batch(() => {
        dispatch(changeRegisteredAppointmentId(response.data[0].id));
        dispatch(changeRegisteredApptTimeslotId(selectedTimeSlot.value));
        dispatch(changeDisplaySelectedDate(selectedDate));
        dispatch(changeDisplaySelectedTime(selectedTimeSlot.label));
        dispatch(changeDisplaySelectedService(selectedService));
        dispatch(changeBookingTxnId(response.data[0].bookingTxnId));
        dispatch(changeTransTime(response.data[0].time));
      });
      if (!defaultLocationId) {
        navigate(APPOINTMENT_ACKNOWLEDGEMENT);
        return;
      }
      navigate(CALL_APPOINTMENT_ACKNOWLEDGEMENT);
    }

    const isFullTimeSlot = response.data.message == "TIME_SLOT_IS_FULL";
    const isAlreadyTaken = response.data.message == "HAVE_ANOTHER_CON";
    const isInvalidData = response.data.message == "INVALID_DATA";

    /*console.log(isInvalidData ? "Invalid data. Please refresh the page and try again."
          : isFullTimeSlot ? "Slot has been booked, please select another slot."
          : "You already have a confirmed booking.");*/

    if (isFullTimeSlot || isAlreadyTaken || isInvalidData) {
      setAlreadyTaken(isAlreadyTaken);
      setIsOpenModal(true);
      setMessage({
        title: "Sorry",
        body: isInvalidData ? "Invalid data. Please refresh the page and try again."
          : isFullTimeSlot ? "Slot has been booked, please select another slot."
          : "You already have a confirmed booking.",
        type: ERROR
      });
    }
  };

  const onChangeMobile = (e) => {
    e.target.value.length < 9 && dispatch(changeMobile(e.target.value));
    setIsVisibleOtpForm(false);
    setVerifiedOTP(false);
  };

  const handleOnSubmitOTP = (e) => {
    e.preventDefault();
    const validateErrors = ValidateMobileData(mobile);
    setValidateErrors(validateErrors);

    (!e.currentTarget.checkValidity() || validateErrors.length === ZERO) &&
      e.stopPropagation();

    setValidated(true);

    if (validateErrors.length !== ZERO) return;
    setIsVisibleOtpForm(true);
  };

  const handleOTPVerify = () => setVerifiedOTP(true);

  const goToAppointmentExistence = () => navigate(APPOINTMENT_EXISTENCE);

  const handleOK = () => {
    setIsOpenModal(false);
  };

  const body = (
    <div className="center">
      <h3>{message.title}</h3>
      <p>{message.body}</p>
    </div>
  );

  const footer = (
    <>
      {message.type === ERROR ? (
        <div>
          <CommonButton
            text={"OK"}
            leftOrRight={"right"}
            onClick={alreadyTaken ? goHome : handleOK}
          />
          {/* <Button
            className="btn cmp-button pbs-style--primary rounded-pill me-3"
            onClick={alreadyTaken ? goHome : handleOK}
          >
            OK
          </Button> */}
        </div>
      ) : (
        <div>
          <Button
            className="btn left-button cmp-button pbs-style--primary rounded-pill me-3"
            onClick={onHideModal}
          >
            No
          </Button>
          <Button
            className="btn cmp-button pbs-style--primary rounded-pill"
            onClick={goHome}
          >
            Yes
          </Button>
        </div>
      )}
    </>
  );

  return (
    <Layout
      subHeader={"How can we help?"}
      mainText={
        <>
          <StepperBar
            title={selectedApptType.label}
            // items={[
            //   { text: "Personal Information", current: true, complete: false },
            //   { text: "Make an Appointment", current: false, complete: false }
            // ]}
            items={stepperItems}
          />
        </>
      }
    >
      <div className="form-box my-5">
        <IconHeader icon={icon} title={displayText} />

        <Form
          className="mt-5"
          noValidate
          validated={validated}
          onSubmit={handleOnSubmitOTP}
        >
          <div className="offset-xl-1 col-xl-10">
            <div className="p-3">
              <div className="mb-3">
                <DataLabel
                  label={"Mode of appointment"}
                  data={selectedApptType.label}
                />

                {bookingTxnId && (
                  <DataLabel
                    label={"Current Booking"}
                    data={
                      <>
                        {!defaultLocationId &&
                          `${displaySelectedService.label}, `}
                        {moment(displaySelectedDate).format(DAY_MONTH_YEAR)}{" "}
                        {displaySelectedTime}
                      </>
                    }
                  />
                  // <div className="mb-3">
                  //   Current Booking :{" "}
                  //   {!defaultLocationId && `${displaySelectedService.label}, `}
                  //   {moment(displaySelectedDate).format(DAY_MONTH_YEAR)}{" "}
                  //   {displaySelectedTime}.
                  // </div>
                )}
                {/* <div className="mb-3">My NRIC is {nric}</div> */}
                <DataLabel label={"NRIC / FIN"} data={nric} />
                <Form.Group className="col-10 col-sm-8 col-md-6 col-lg-5">
                  <InputText
                    label="Singapore-registered Mobile Number"
                    type="number"
                    placeholder="Mobile number"
                    value={mobile}
                    onChange={onChangeMobile}
                    isInvalid={validateErrors[MOBILE_INDEX]}
                    errorMessage={validateErrors[MOBILE_INDEX]}
                  />

                  {/* <Form.Label>My mobile number is</Form.Label>
                  <Form.Control
                    type="number"
                    className="form-control"
                    placeholder="Mobile"
                    value={mobile}
                    onChange={onChangeMobile}
                    isInvalid={validateErrors[MOBILE_INDEX]}
                    required
                  />
                  <Form.Control.Feedback type="invalid">
                    {validateErrors[MOBILE_INDEX]}
                  </Form.Control.Feedback> */}
                </Form.Group>
                <div className="col-12" style={{ fontStyle: "italic" }}>
                  You will receive notifications on CPF Appointment Services via
                  SMS.
                  <br /> One-Time Password (OTP) SMS verification is required.
                </div>
              </div>
            </div>
            {isVisibleOtpForm && <SeparatorLine />}
          </div>
          {!isVisibleOtpForm && (
            <div className="form-footer justify-content-end align-items-end">
              <NextButton text={"Get OTP Code"} type="submit" />
              {/* <Button
                className="btn cmp-button pbs-style--primary rounded-pill"
                type="submit"
              >
                Get OTP Code
              </Button> */}
            </div>
          )}
        </Form>

        {isVisibleOtpForm && !verifiedOTP && (
          <OTP className="my-4" onClick={handleOTPVerify} />
        )}

        {verifiedOTP && !defaultLocationId && (
          <AppointmentBookingForm
            onOpenModal={onConfirm}
            onSubmit={handleAppointment}
            onNavigate={goToAppointmentExistence}
          />
        )}
        {verifiedOTP && defaultLocationId && (
          <CallAppointmentBooking
            onOpenModal={onConfirm}
            onSubmit={handleAppointment}
            onNavigate={goToAppointmentExistence}
          />
        )}
        <Modal
          isOpen={isOpenModal}
          onHide={onHideModal}
          body={body}
          footer={footer}
          closeButton={message.type !== ERROR}
        />
      </div>
    </Layout>
  );
}
